import mixpanel from "mixpanel-browser";

export const ANALYTICS_TYPES = {
  SIGN_IN: "Login",
  SIGN_OUT: "Logout",
  SIGN_UP: "SignUp",
  ACCEPTED_TERMS: "AcceptTerms",
  ONBOARDING_STARTED: "OnboardingStarted",
  ONBOARDING_ENDED: "OnboardingEnded",
  CONNECT_DEVICE: "ConnectDevice",
  DEVICE_CONNECTED: "DeviceConnected",
  START_BREW_PACK: "StartBrewPackBrew",
  START_CUSTOM_RECIPE: "StartCustomRecipe",
  SCREEN_LOAD: "ScreenLoad",
  ERROR_REPORT: "ErrorReport",
  SET_SERVING_TEMP: "SetServingTemp",
  OPEN_MENU: "OpenMenu",
  OPEN_MENU_ITEM: "SelectMenuItem",
  FERMENTATION_INTERRUPTED_SHOWN: "FermentationInterruptedShown",
  FERMENTATION_INTERRUPTED_RESUME: "FermentationInterruptedResume",
  FERMENTATION_PANIC_RETRY: "FermentationPanicRetry",
};

// A wrapper for the analytics
const analyticsService = {
  mixpanel,
  init: function () {
    // Skip init when no token is configured (e.g. local development).
    // Calling mixpanel.init('') leaves the client uninitialized and makes
    // subsequent register/track calls crash internally.
    if (!"0d9bbea6d40f462378440334843050e0") return;

    mixpanel.init("0d9bbea6d40f462378440334843050e0");
  },
  register: function () {
    if (!"0d9bbea6d40f462378440334843050e0") return;

    const superProperties = {
      "App Version": "1.73.51" || "development",
    };
    mixpanel.register(superProperties);
  },
  track: function (eventName, properties) {
    if (!"0d9bbea6d40f462378440334843050e0") return;

    mixpanel.track(eventName, properties);
  },
};

export default analyticsService;
